import { observer } from "mobx-react-lite";
import { Target } from "lucide-react";
import { useTran } from "@/hooks";
import { useAuthStore } from "@/features/auth/hooks";
import { useEntryDataStore } from "../../hooks/useDataEntryStore";
import { formatMetricValue } from "../../domains/dataEntry";

const TargetLabel = observer(({ disclosureId, organizationId, year }) => {
  const { t } = useTran();
  const { user } = useAuthStore();
  const { getTarget } = useEntryDataStore();

  if (!disclosureId || !organizationId || organizationId === "all" || !year)
    return null;

  const isParentCompany =
    organizationId && user?.companyId && organizationId === user.companyId;
  const orgId = isParentCompany ? null : organizationId;
  const target = getTarget(orgId, year);

  if (!target?.targetData || target.targetData.value == null) return null;

  return (
    <span className="flex items-center gap-1 text-xs text-muted-foreground">
      <Target size={12} className="text-primary" />
      <span>{t("Target")}:</span>
      <span className="font-semibold text-primary">
        {formatMetricValue(target.targetData.value)}
        {target.targetData.unit && ` ${target.targetData.unit}`}
      </span>
    </span>
  );
});

export default TargetLabel;
